// extracted by mini-css-extract-plugin
export default {"menuHeight":"72px","link-item":"nav-link_link-item__PVFmG","notification-count":"nav-link_notification-count__wsVMV","active":"nav-link_active__Uu3-P"};